import React from "react";
import { AccountTemplate } from "../../../components/templates";

function Account() {
  return <AccountTemplate />;
}

export default Account;
